const RE_MULTI_SLASH = /\/{2,}/g;
const REPLACE_VALUE = '/';

export const normalizeUrl = (value: string) => {
    try {
        const url = new URL(value);

        url.pathname = url.pathname.replace(RE_MULTI_SLASH, REPLACE_VALUE);

        return url.toString();
    } catch(error) {
        return value.replace(RE_MULTI_SLASH, REPLACE_VALUE);
    }
};
